import React from "react";

/* mui */
import Grid from "@material-ui/core/Grid";
/* mui */

const wrapper = (props) => {
  return (
    <Grid item xs={12} sm={12} md={3} lg={4} xl={4}>
      {props.children}
    </Grid>
  );
};

export default wrapper;
